<admin-app-header></admin-app-header>
<app-enterprise-admin-bar></app-enterprise-admin-bar>

<div class="parkings-page">
    <div class="container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <h1>Buildings / Parkings</h1>
        </div>

        <!-- Summary Stats -->
        <div class="stats-grid">
            <div class="stat-card stat-card--blue">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-square-parking"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Total Parkings</span>
                    <span class="stat-card__value">{{ getTotalParkings() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--green">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-circle-check"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Published</span>
                    <span class="stat-card__value">{{ getPublishedCount() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--orange">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-pen-to-square"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Pending / Draft</span>
                    <span class="stat-card__value">{{ getDraftCount() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--red">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-trash-can"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Deleted / Disabled</span>
                    <span class="stat-card__value">{{ getDeletedCount() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--teal">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-location-crosshairs"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">No Address</span>
                    <span class="stat-card__value">{{ getNoAddressCount() }}</span>
                </div>
            </div>
        </div>

        <!-- Filter Bar -->
        <div class="filter-bar">
            <div class="filter-bar__left">
                <select class="status-select" [ngModel]="activeFilter" (ngModelChange)="setFilter($event)">
                    <option value="ALL">All Statuses</option>
                    <option *ngFor="let status of parkingStatuses" [value]="status">{{ status }}</option>
                </select>
                <div class="search-box">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    <input type="text" placeholder="Search by name, merchant, city..." [(ngModel)]="searchQuery" (ngModelChange)="applySearch()">
                </div>
            </div>
            <div class="filter-bar__right">
                <span class="results-count">{{ filteredParkings?.length || 0 }} results</span>
            </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="filteredParkings && filteredParkings.length === 0">
            <i class="fa-solid fa-square-parking"></i>
            <h3>No parkings found</h3>
            <p>There are no parkings matching your filters.</p>
        </div>

        <!-- Parkings Table -->
        <div class="table-card" *ngIf="filteredParkings && filteredParkings.length > 0">
            <table class="parkings-table">
                <thead>
                    <tr>
                        <th>Created</th>
                        <th>Type</th>
                        <th>Term</th>
                        <th>Status</th>
                        <th>Name</th>
                        <th>Merchant</th>
                        <th>Bays</th>
                        <th>Bank</th>
                        <th>Address</th>
                        <th>Use Policy</th>
                        <th>Lease</th>
                        <th>Admyt</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let parking of filteredParkings" 
                        (contextmenu)="showContextMenu($event, parking)" 
                        class="parking-row"
                        [class.selected]="selectedParking === parking">
                        <td>
                            <span class="date-text">{{ parking.createdAt | formatDate }}</span>
                        </td>
                        <td>
                            <span class="type-badge" [ngClass]="'type-badge--' + parking.parkingType?.toLowerCase()">
                                {{ EnumNames.getParkingTypeNiceName(parking.parkingType) }}
                            </span>
                        </td>
                        <td>
                            <span *ngIf="parking.isMonthToMonth" class="badge text-white" style="background-color: #7A62A3; font-size: 0.75em">Month-to-Month</span>
                            <span *ngIf="!parking.isMonthToMonth" class="badge text-white" style="background-color: #405C84; font-size: 0.75em">Fixed Term</span>
                        </td>
                        <td>
                            <span *ngIf="parking.parkingStatus == parkingStatus.DISABLED" class="status-badge status-badge--disabled">Deleted</span>
                            <span *ngIf="parking.parkingStatus == parkingStatus.PUBLISHED" class="status-badge status-badge--published">Published</span>
                            <span *ngIf="parking.parkingStatus == parkingStatus.NEW" class="status-badge status-badge--draft">Draft</span>
                            <span *ngIf="parking.parkingStatus == parkingStatus.PENDING" class="status-badge status-badge--draft">Pending</span>
                            <span *ngIf="parking.parkingStatus == parkingStatus.PRIVATE" class="status-badge status-badge--private">Private</span>
                        </td>
                        <td>
                            <a [routerLink]="['/parking', parking.$key]" class="parking-link">
                                <span class="parking-name">{{ parking.title | slice: 0:30 }}</span>
                                <span *ngIf="!parking.title" class="text-undefined">Undefined</span>
                            </a>
                            <span *ngIf="parking.updatedAt && this.getDaysAgo(parking.updatedAt) <= 30" class="updated-badge">
                                Updated {{ parking.updatedAt | daysAgo }}
                            </span>
                        </td>
                        <td>
                            <a *ngIf="parking.merchantRef" [routerLink]="['/merchant/', parking.merchantRef.id]" class="merchant-link">
                                <span [class.text-undefined]="!parking.denormMerchantCompanyName">
                                    {{ parking.denormMerchantCompanyName || 'Not set' }}
                                </span>
                            </a>
                        </td>
                        <td>
                            <span *ngIf="parking.numberOfBays" class="count-badge">
                                <i class="fa-solid fa-car"></i> {{ parking.numberOfBays }}
                            </span>
                            <span *ngIf="!parking.numberOfBays" class="text-muted">—</span>
                        </td>
                        <td>
                            <span *ngIf="parking.$merchant && parking.$merchant.payoutDetails" class="count-badge count-badge--success">
                                <i class="fa-solid fa-building-columns"></i> {{ parking.$merchant.payoutDetails.bank | slice:0:10 }}
                            </span>
                            <span *ngIf="!parking.$merchant || !parking.$merchant.payoutDetails" class="missing-badge">
                                <i class="fa-solid fa-exclamation-triangle"></i> Missing
                            </span>
                        </td>
                        <td>
                            <span *ngIf="parking.parkingLocation?.streetNumber" class="data-text">
                                <i class="fa-solid fa-location-dot"></i> {{ parking.parkingLocation.city }}
                            </span>
                            <span *ngIf="!parking.parkingLocation?.streetNumber" class="missing-badge">
                                <i class="fa-solid fa-exclamation-triangle"></i> Missing
                            </span>
                        </td>
                        <td>
                            <a *ngIf="parking.usePolicyUrl" class="action-link" [href]="parking.usePolicyUrl" target="_blank">
                                <i class="fa-solid fa-file-lines"></i> View
                            </a>
                            <span *ngIf="!parking.usePolicyUrl" class="missing-badge">
                                <i class="fa-solid fa-exclamation-triangle"></i>
                            </span>
                        </td>
                        <td>
                            <a *ngIf="parking.leaseAgreementUrl" class="action-link" [href]="parking.leaseAgreementUrl" target="_blank">
                                <i class="fa-solid fa-file-signature"></i> View
                            </a>
                            <span *ngIf="!parking.leaseAgreementUrl" class="text-muted">—</span>
                        </td>
                        <td>
                            <a *ngIf="parking.admytCenter" class="action-link" [routerLink]="['/admin/admyt-center', parking.admytCenter]">
                                <i class="fa-solid fa-building-shield"></i> View
                            </a>
                            <span *ngIf="!parking.admytCenter" class="text-muted">—</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
